// extracted by mini-css-extract-plugin
export default {"testimonial":"vxxtj1","starIcon":"sF2ZHp","testimonialText":"NVmTt6","starcheck":"ylA2jn"};